import { cn } from "@/lib/utils"
import { Section, Eyebrow } from "./Section"

const PILLARS = [
  {
    name: "Authority Strategy",
    body: "Clarify the show's business role, audience, offer alignment, and positioning.",
  },
  {
    name: "Relationship Map",
    body: "Identify the categories of people worth building around: ideal clients, referral partners, collaborators, industry peers, and credibility partners.",
  },
  {
    name: "Guest Pipeline Intelligence",
    body: "Research and prioritize strategic guest opportunities each month, with context and outreach templates so invitations feel relevant and thoughtful.",
  },
  {
    name: "Conversation System",
    body: "Prepare host briefs, guest notes, interview questions, and episode angles so every recording has a clear purpose.",
  },
  {
    name: "Weekly Video Production",
    body: "Produce polished weekly video podcast episodes, including editing, publishing, and episode packaging.",
  },
  {
    name: "Content Multiplication",
    body: "Repurpose conversations into show notes, clips, posts, and other assets that extend the value of every episode.",
  },
  {
    name: "Monthly Strategic Review",
    body: "Review content momentum, guest strategy, relationship opportunities, and next steps together.",
  },
]

export function Offer() {
  return (
    <Section id="offer">
      <div className="max-w-2xl">
        <Eyebrow>The offer</Eyebrow>
        <h2 className="display-2 mt-4">The FullCast Podcast Growth Partnership</h2>
        <p className="mt-5 text-lg text-ink-body">
          A six-month podcast strategy, production, and relationship-building
          partnership for established experts who want their podcast to support
          authority, visibility, trust, and strategic relationships.
        </p>
      </div>

      <ol className="mt-12 grid gap-px overflow-hidden rounded-xl border border-hairline bg-hairline sm:grid-cols-2 lg:grid-cols-3">
        {PILLARS.map((pillar, i) => (
          <li
            key={pillar.name}
            className={cn(
              "bg-page p-6",
              // 7 pillars into a 2-/3-col grid leaves the last cell orphaned
              // with dead space beside it — span the final row instead.
              i === PILLARS.length - 1 && "sm:col-span-2 lg:col-span-3",
            )}
          >
            <div className="font-display text-sm font-semibold text-accent-display">
              {String(i + 1).padStart(2, "0")}
            </div>
            <h3 className="mt-3">{pillar.name}</h3>
            <p className="mt-2 text-sm text-ink-muted">{pillar.body}</p>
          </li>
        ))}
      </ol>
    </Section>
  )
}
